import { actionTypes } from '../actions/actionTypes/ProjectMaintnanceActionTypes';

let initialState = {
  ClosedProjectCaseList: [],
  ProjectMaintenanceGetCallData: {},
  formBasicData: {},
  InflightProjectCaseList: [],
  SavedProjectCaseList: [],
  saveOrSubmitData: {},
  ProjectCaseList: [],
  ClientCaseList: [],
  getProjectMaintnanceLoader: false,
  projectsList: [],
  searchProjectsLoader: false,
  ProjectInfo: {},
  invoiceContext: {},
  invoiceResources: [],
  invoiceDate: '',
  dueDate: '',
  invoicePeriodStartDate: '',
  invoicePeriodEndDate: '',
  weekNumber: '',
  invoiceMonth: '',
  billingMonth: '',
  noOfDays: '',
  projectedInvoiceAmount: 0,
  getResourcesLoader: false,
  invoiceCaseDetails: {},
  openInvoiceCaseLoader: false,
  invoiceDetailsData: {},
  getInvoiceDetailsLoader: false,
  voidInvoiceLoader: false,
  ClientAttachments: [],
  submitSuccessNote: '',
  saveSuccessNote: '',
  editData: {},
  labelForSavedCases: '',
  loaderForEditProject: false,
  ProjectMaintenanceOptionMenu: [],
  openProjecttLoader: false,
  pagination: 0,
  pagesSates: {
    EnableProjectDetailsPage: false,
    EnableCreateOrEditProject: 0,
    EnableCloseProject: 0,
  },
  formLists: {},
  PaymentTermList: [],
  AllowedPastDays: 0,
  formBasicDataLoader: false,
  projectData: {},
  ResourceNeedCaseInfo: {},
  resourceNeedCaseLoader: false,
  SwapResourceCaseInfo: {},
  searchEmpProjectsLoader: false,
  SwappeProjectsList: [],
  swapResourceLoader: false,
  SwapperDetails: {},
  swapCaseDetailsLoader: false,
  SwapCaseDetails: {},
  ActiveEmployeeList: [],
  closePopup: false,
  WarningMessage: '',
  RNData: {},
  pyFileName: '',
  EmployeeResumeBase64: '',
  resumeFetchLoader: false,
  skills: [],
  showskillLoader: false,
  certifications: [],
  isCaseWithdrawnSuccessfully: false,
  withdrawCaseLoader: false,
  ClientDetails: [],
  ClientNamesList: [],
  retryProjectSyncLoader: false,
  auditHistory: [],
  auditHistoryLoader: false,
  HCMOrg: '',
  IsProjectManager: false,
  saveOrSubmitInvoiceData: {},
  saveInvoiceSuccessNote: '',
  submitInvoiceSuccessNote: '',
  loaderForSaveInvoice: false,
  loaderForSubmitInvoice: false,
  updateClientStatusLoader: false,
  checkInactiveEligibilityLoader: false,
};
/**
 * Redux reducers.
 * Used to update state in the store after actions are issued.
 */
export function projectMaintenanceReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_PROJECT_MAINTENANCE_SUCCESS:
      return {
        ...state,
        ClosedProjectCaseList: action.cases?.ClosedProjectCaseList || [],
        ClientDetails: action.cases?.ClientDetails || [],
        ClientNamesList: action.cases?.ClientNamesList || [],
        ClientCases: action.cases?.ClientCases || [],
        ProjectMaintenanceGetCallData: action?.cases || {},
        InflightProjectCaseList: action.cases?.InflightProjectCaseList || [],
        formBasicData: action.cases?.ProjectInfo || {},
        PaymentTermList:
          action.cases?.PaymentTermList ||
          action.cases?.ProjectInfo?.PaymentTermList ||
          action.cases?.ProjectInfo?.ProjectBillingDetails?.PaymentTermList ||
          [],
        AllowedPastDays: action.cases?.AllowedPastDays || 0,
        pagination: action.cases?.PageIndexCount,
        saveOrSubmitData: {},
        submitSuccessNote: '',
        saveSuccessNote: '',
        ProjectCaseList: action.cases.ProjectCaseList || [],
        ClientCaseList: action.cases?.ClientCaseList || [],
        SavedProjectCaseList: action.cases.SavedProjectCaseList || [],
        getProjectMaintnanceLoader: false,
        WarningMessage: '',
        HCMOrg: action.cases.HCMOrg || '',
        pagesSates: {
          ...state.pagesSates,
          EnableProjectDetailsPage: false,
        },
        ClientAttachments: [],
        auditHistory: [],
      };

    case actionTypes.GET_PROJECT_MAINTENANCE_FIALURE:
      return {
        ...state,
        formBasicData: {},
        ClosedProjectCaseList: [],
        InflightProjectCaseList: [],
        saveOrSubmitData: {},
        ProjectCaseList: [],
        ClientCaseList: [],
        getProjectMaintnanceLoader: false,
        pagesSates: {
          ...state.pagesSates,
          EnableProjectDetailsPage: false,
        },
      };

    case actionTypes.GET_PROJECT_MAINTENANCE__LOADER:
      return {
        ...state,
        getProjectMaintnanceLoader: true,
        pagesSates: {
          ...state.pagesSates,
          EnableProjectDetailsPage: false,
        },
      };
    case actionTypes.SEARCH_PROJECT_SUCCESS:
      return {
        ...state,
        projectsList: action?.cases?.ProjectMaintenanceSearchList || [],
        searchProjectsLoader: false,
      };

    case actionTypes.SEARCH_PROJECT_FAILURE:
      return {
        ...state,
        projectsList: [],
        searchProjectsLoader: false,
      };

    case actionTypes.SEARCH_PROJECT_LOADER:
      return {
        ...state,
        searchProjectsLoader: true,
      };

    case actionTypes.OPEN_PROJECT_SUCCESS:
      return {
        ...state,
        ProjectInfo: action.cases.ProjectInfo || {},
        IsProjectManager:
          action.cases?.IsProjectManager ??
          action.cases?.ProjectInfo?.IsProjectManager ??
          false,
        ProjectMaintenanceOptionMenu: action.cases.ProjectMaintenanceOptionMenu || [],
        IsEligibleForAction:
          (action.cases?.ClientDetails || [])
            .flatMap((client) => client?.ProjectDetails || [])
            .find((project) => project?.ID === action.cases?.ProjectInfo?.ID)
            ?.IsEligibleForAction === 'true',
        openProjecttLoader: false,
        pagesSates: {
          ...state.pagesSates,
          EnableProjectDetailsPage: true,
        },
        ResourceNeedCaseInfo: action.cases?.ResourceNeedCaseInfo || {},
        SwapResourceCaseInfo: action.cases?.SwapResourceCaseInfo || {},
        distinctListOfResources: action.cases?.distinctListOfResources || [],
      };

    case actionTypes.OPEN_PROJECT_FAILURE:
      return {
        ...state,
        ProjectInfo: {},
        ProjectMaintenanceOptionMenu: [],
        IsProjectManager: false,
        openProjecttLoader: false,
      };

    case actionTypes.OPEN_PROJECT_LOADER:
      return {
        ...state,
        openProjecttLoader: true,
      };

    case actionTypes.FETCH_RESUME_SUCCESS:
      return {
        ...state,
        pyFileName: action?.data?.pyFileName || '',
        EmployeeResumeBase64: action?.data?.EmployeeResumeBase64 || '',
        resumeFetchLoader: false,
      };

    case actionTypes.FETCH_RESUME_FAILURE:
      return {
        ...state,
        resumeFetchLoader: false,
      };

    case actionTypes.SHOW_RESUME_FETCH_LOADER:
      return {
        ...state,
        resumeFetchLoader: true,
      };

    case actionTypes.SET_DATA_PROJECT_MAINTENANCE:
      return {
        ...state,
        pagesSates: {
          EnableProjectDetailsPage: action.data.EnableProjectDetailsPage,
          EnableCreateOrEditProject: action.data.EnableCreateOrEditProject,
          EnableCloseProject: action.data.EnableCloseProject,
        },
        editData: action.data.editData ? action.data.editData : state.editData || {},
        saveOrSubmitData: action?.data?.saveOrSubmitData || {},
        labelForSavedCases: action?.data?.labelForSavedCases || '',
        saveOrSubmitInvoiceData: action?.data?.saveOrSubmitInvoiceData || {},
        saveInvoiceSuccessNote: action?.data?.saveInvoiceSuccessNote || '',
        submitInvoiceSuccessNote: action?.data?.submitInvoiceSuccessNote || '',
        saveSuccessNote: action?.data?.saveSuccessNote || '',
        submitSuccessNote: action?.data?.submitSuccessNote || '',
      };

    case actionTypes.SET_INVOICE_CONTEXT:
      return {
        ...state,
        invoiceContext: action.data || {},
      };

    case actionTypes.GET_RESOURCES_SUCCESS:
      return {
        ...state,
        invoiceResources: action.cases?.InvoiceResourceList || [],
        invoiceDate: action.cases?.InvoiceDate || '',
        dueDate: action.cases?.DueDate || '',
        invoicePeriodStartDate: action.cases?.InvoicePeriodStartDate || '',
        invoicePeriodEndDate: action.cases?.InvoicePeriodEndDate || '',
        weekNumber: action.cases?.WeekNumber || '',
        invoiceMonth: action.cases?.MonthName || '',
        billingMonth: action.cases?.BillingMonth || '',
        noOfDays: action.cases?.NoOfDays || '',
        projectedInvoiceAmount: action.cases?.ProjectedInvoiceAmount || 0,
        getResourcesLoader: false,
      };
    case actionTypes.GET_RESOURCES_FAILURE:
      return {
        ...state,
        invoiceResources: [],
        invoiceDate: '',
        dueDate: '',
        invoicePeriodStartDate: '',
        invoicePeriodEndDate: '',
        weekNumber: '',
        invoiceMonth: '',
        billingMonth: '',
        noOfDays: '',
        projectedInvoiceAmount: 0,
        getResourcesLoader: false,
      };
    case actionTypes.GET_RESOURCES_LOADER:
      return {
        ...state,
        getResourcesLoader: true,
      };

    // Response shape isn't guaranteed to nest under ProjectInfo (some case
    // endpoints return it flat, like GET_RESOURCES_SUCCESS above) — read
    // defensively so either shape populates the view.
    case actionTypes.OPEN_INVOICE_CASE_SUCCESS: {
      // IsInvoiceReadOnly rides as a sibling of ProjectInfo, not inside it —
      // fold it in explicitly so it isn't dropped when the nested shape wins.
      const invoiceCase = action.cases?.ProjectInfo
        ? { ...action.cases.ProjectInfo, IsInvoiceReadOnly: action.cases.IsInvoiceReadOnly }
        : action.cases || {};
      return {
        ...state,
        invoiceCaseDetails: invoiceCase,
        invoiceResources: invoiceCase.InvoiceResourceList || [],
        invoiceDate: invoiceCase.InvoiceDate || '',
        dueDate: invoiceCase.DueDate || '',
        invoicePeriodStartDate: invoiceCase.InvoicePeriodStartDate || '',
        invoicePeriodEndDate: invoiceCase.InvoicePeriodEndDate || '',
        weekNumber: invoiceCase.WeekNumber || '',
        invoiceMonth: invoiceCase.Invoicemonth || '',
        billingMonth: invoiceCase.BillingMonth || '',
        noOfDays: invoiceCase.NoOfDays || '',
        projectedInvoiceAmount:
          invoiceCase.ProjectedInvoiceAmount || invoiceCase.CalculatedInvoiceAmount || 0,
        openInvoiceCaseLoader: false,
      };
    }
    case actionTypes.OPEN_INVOICE_CASE_FAILURE:
      return {
        ...state,
        invoiceCaseDetails: {},
        openInvoiceCaseLoader: false,
      };
    case actionTypes.OPEN_INVOICE_CASE_LOADER:
      return {
        ...state,
        openInvoiceCaseLoader: true,
      };

    case actionTypes.GET_INVOICE_DETAILS_SUCCESS:
      return {
        ...state,
        invoiceDetailsData: action.cases?.ProjectInfo || action.cases || {},
        getInvoiceDetailsLoader: false,
      };
    case actionTypes.GET_INVOICE_DETAILS_FAILURE:
      return {
        ...state,
        invoiceDetailsData: {},
        getInvoiceDetailsLoader: false,
      };
    case actionTypes.GET_INVOICE_DETAILS_LOADER:
      return {
        ...state,
        getInvoiceDetailsLoader: true,
      };

    case actionTypes.VOID_INVOICE_SUCCESS:
      return {
        ...state,
        voidInvoiceLoader: false,
      };
    case actionTypes.VOID_INVOICE_FAILURE:
      return {
        ...state,
        voidInvoiceLoader: false,
      };
    case actionTypes.VOID_INVOICE_LOADER:
      return {
        ...state,
        voidInvoiceLoader: true,
      };

    case actionTypes.UPDATE_CLIENT_STATUS_SUCCESS:
      return {
        ...state,
        updateClientStatusLoader: false,
      };
    case actionTypes.UPDATE_CLIENT_STATUS_FAILURE:
      return {
        ...state,
        updateClientStatusLoader: false,
      };
    case actionTypes.UPDATE_CLIENT_STATUS_LOADER:
      return {
        ...state,
        updateClientStatusLoader: true,
      };

    case actionTypes.CHECK_INACTIVE_ELIGIBILITY_SUCCESS:
      return {
        ...state,
        checkInactiveEligibilityLoader: false,
      };
    case actionTypes.CHECK_INACTIVE_ELIGIBILITY_FAILURE:
      return {
        ...state,
        checkInactiveEligibilityLoader: false,
      };
    case actionTypes.CHECK_INACTIVE_ELIGIBILITY_LOADER:
      return {
        ...state,
        checkInactiveEligibilityLoader: true,
      };

    case actionTypes.RESET_INVOICE_DATA:
      return {
        ...state,
        invoiceResources: [],
        invoiceDate: '',
        dueDate: '',
        invoicePeriodStartDate: '',
        invoicePeriodEndDate: '',
        weekNumber: '',
        invoiceMonth: '',
        billingMonth: '',
        noOfDays: '',
        projectedInvoiceAmount: 0,
        invoiceCaseDetails: {},
      };

    case actionTypes.RESET_INVOICE_RESOURCE_DATA:
      return {
        ...state,
        invoiceResources: [],
        invoiceDate: '',
        dueDate: '',
        invoicePeriodStartDate: '',
        invoicePeriodEndDate: '',
        weekNumber: '',
        invoiceMonth: '',
        billingMonth: '',
        noOfDays: '',
        projectedInvoiceAmount: 0,
      };

    case actionTypes.GET_fORM_BASICDATA_SUCCESS:
      return {
        ...state,
        formLists: action.cases.ProjectInfo || {},
        PaymentTermList:
          action.cases?.PaymentTermList ||
          action.cases?.ProjectInfo?.PaymentTermList ||
          action.cases?.ProjectInfo?.ProjectBillingDetails?.PaymentTermList ||
          [],
        AllowedPastDays: action.cases?.AllowedPastDays || 0,
        ActiveEmployeeList: action.cases.ActiveEmployeeList || [],
        formBasicDataLoader: false,
      };
    case actionTypes.GET_fORM_BASICDATA_FAILURE:
      return {
        ...state,
        formLists: {},
        formBasicDataLoader: false,
      };
    case actionTypes.GET_fORM_BASICDATA_LOADER:
      return {
        ...state,
        formBasicDataLoader: true,
      };

    case actionTypes.SAVE_SUCCESS:
      return {
        ...state,
        saveOrSubmitData: action?.cases || {},
        saveSuccessNote: action?.cases?.pyNote,
        loaderForSaveProject: false,
        submitSuccessNote: '',
      };

    case actionTypes.SAVE_FAILURE:
      return {
        ...state,
        SavedProjectCaseList: [],
        pagination: 0,
        saveOrSubmitData: {},
        saveSuccessNote: '',
        submitSuccessNote: '',
        loaderForSaveProject: false,
      };
    case actionTypes.SAVE_LOADER:
      return {
        ...state,
        loaderForSaveProject: true,
      };

    case actionTypes.SUBMIT_SUCCESS:
      return {
        ...state,
        saveOrSubmitData: action.cases || {},
        submitSuccessNote: action?.cases?.pyNote,
        WarningMessage: action?.cases?.ProjectInfo?.WarningMessage || '',
        saveSuccessNote: '',
        loaderForSubmitProject: false,
      };
    case actionTypes.SUBMIT_FAILURE:
      return {
        ...state,
        saveOrSubmitData: {},
        saveSuccessNote: '',
        submitSuccessNote: '',
        loaderForSubmitProject: false,
        WarningMessage: '',
      };
    case actionTypes.SUBMIT_LOADER:
      return {
        ...state,
        loaderForSubmitProject: true,
      };

    case actionTypes.SAVE_INVOICE_SUCCESS:
      return {
        ...state,
        saveOrSubmitInvoiceData: action?.cases || {},
        saveInvoiceSuccessNote: action?.cases?.pyNote,
        loaderForSaveInvoice: false,
        submitInvoiceSuccessNote: '',
      };
    case actionTypes.SAVE_INVOICE_FAILURE:
      return {
        ...state,
        saveOrSubmitInvoiceData: {},
        loaderForSaveInvoice: false,
      };
    case actionTypes.SAVE_INVOICE_LOADER:
      return {
        ...state,
        loaderForSaveInvoice: true,
      };

    case actionTypes.SUBMIT_INVOICE_SUCCESS:
      return {
        ...state,
        saveOrSubmitInvoiceData: action?.cases || {},
        submitInvoiceSuccessNote: action?.cases?.pyNote,
        saveInvoiceSuccessNote: '',
        loaderForSubmitInvoice: false,
      };
    case actionTypes.SUBMIT_INVOICE_FAILURE:
      return {
        ...state,
        saveOrSubmitInvoiceData: {},
        loaderForSubmitInvoice: false,
      };
    case actionTypes.SUBMIT_INVOICE_LOADER:
      return {
        ...state,
        loaderForSubmitInvoice: true,
      };

    case actionTypes.EDIT_PROJECT_SUCCESS:
      return {
        ...state,
        ClientAttachments: action?.cases?.ClientAttachments || [],
        ProjectInfo: action?.cases?.ProjectInfo || {},
        labelForSavedCases: action?.cases?.ProcessType,
        projectData: action?.cases,
        loaderForEditProject: false,
      };
    case actionTypes.EDIT_PROJECT_FAILURE:
      return {
        ...state,
        labelForSavedCases: '',
        ProjectInfo: {},
        loaderForEditProject: false,
      };
    case actionTypes.EDIT_PROJECT_LOADER:
      return {
        ...state,
        loaderForEditProject: true,
      };

    case actionTypes.SET_DATA_CASE_AUTHENTICATION:
      return {
        ...state,
        projectData: {},
      };

    case actionTypes.RESET_SWAP_DATA:
      return {
        ...state,
        SwappeProjectsList: [],
        closePopup: false,
        SwapperDetails: {},
        ActiveEmployeeList: [],
      };

    case actionTypes.RESOURCE_NEED_CASE_SUCCESS:
      return {
        ...state,
        resourceNeedCaseLoader: false,
        RNData: action?.data || {},
        holdedResources: action?.data?.HoldedEmployeeList || [],
        reservedResources: action?.data?.ReserveEmployeeList || [],
        allocatedResources: action?.data?.AllocatedEmployeeList || [],
      };
    case actionTypes.RESOURCE_NEED_CASE_FAILURE:
      return {
        ...state,
        resourceNeedCaseLoader: false,
      };
    case actionTypes.RESOURCE_NEED_CASE_LOADER:
      return {
        ...state,
        resourceNeedCaseLoader: true,
      };

    case actionTypes.SEARCH_EMP_PROJECT_SUCCESS:
      return {
        ...state,
        searchEmpProjectsLoader: false,
        SwappeProjectsList: action?.cases?.SwappeProjectsList || [],
        SwapperDetails: action.cases?.SwapperDetails || {},
      };
    case actionTypes.SEARCH_EMP_PROJECT_FAILURE:
      return {
        ...state,
        searchEmpProjectsLoader: false,
      };
    case actionTypes.SEARCH_EMP_PROJECT_LOADER:
      return {
        ...state,
        searchEmpProjectsLoader: true,
      };

    case actionTypes.SUBMIT_SWAP_SUCCESS:
      return {
        ...state,
        swapResourceLoader: false,
        closePopup: true,
      };
    case actionTypes.SUBMIT_SWAP_FAILURE:
      return {
        ...state,
        swapResourceLoader: false,
        closePopup: false,
      };
    case actionTypes.SUBMIT_SWAP_LOADER:
      return {
        ...state,
        swapResourceLoader: true,
      };

    case actionTypes.SWAP_CASE_DETAILS_SUCCESS:
      return {
        ...state,
        swapCaseDetailsLoader: false,
        SwapCaseDetails: action.data,
      };
    case actionTypes.SWAP_CASE_DETAILS_FAILURE:
      return {
        ...state,
        swapCaseDetailsLoader: false,
      };
    case actionTypes.SWAP_CASE_DETAILS_LOADER:
      return {
        ...state,
        swapCaseDetailsLoader: true,
      };

    case actionTypes.CLEAR_WARNING_MSG:
      return {
        ...state,
        WarningMessage: '',
      };
    case actionTypes.SHOW_SKILL_SUCCESS:
      return {
        ...state,
        showskillLoader: false,
        skills: action?.data?.EmployeeSkillsList || [],
        certifications: action?.data?.EmployeeCertificationList || [],
      };
    case actionTypes.SHOW_SKILL_FAILURE:
      return {
        ...state,
        showskillLoader: false,
      };

    case actionTypes.SHOW_SKILL_UPDATE_LOADER:
      return {
        ...state,
        showskillLoader: true,
      };
    case actionTypes.WITHDRAW_PM_CASE_SUCCESS:
      return {
        ...state,
        withdrawCaseLoader: false,
        isCaseWithdrawnSuccessfully: true,
      };
    case actionTypes.WITHDRAW_PM_CASE_FAILURE:
      return {
        ...state,
        withdrawCaseLoader: false,
        isCaseWithdrawnSuccessfully: false,
      };

    case actionTypes.WITHDRAW_PM_CASE_LOADER:
      return {
        ...state,
        withdrawCaseLoader: true,
      };

    case actionTypes.RETRY_PROJECT_SYNC_SUCCESS:
      return {
        ...state,
        ProjectInfo: {
          ...state.ProjectInfo,
          SyncStatus: action.cases?.SyncStatus || 'Success',
        },
        retryProjectSyncLoader: false,
      };
    case actionTypes.RETRY_PROJECT_SYNC_FAILURE:
      return {
        ...state,
        retryProjectSyncLoader: false,
      };
    case actionTypes.RETRY_PROJECT_SYNC_LOADER:
      return {
        ...state,
        retryProjectSyncLoader: true,
      };

    case actionTypes.GET_AUDIT_HISTORY_SUCCESS:
      return {
        ...state,
        auditHistory:
          action.cases?.AuditHistory ||
          action.cases?.ProjectInfo?.ProjectAuditHistory ||
          action.cases?.ProjectInfo?.ClientAuditHistory ||
          action.cases?.ProjectInfo?.InvoiceHistory ||
          [],
        auditHistoryLoader: false,
      };
    case actionTypes.GET_AUDIT_HISTORY_FAILURE:
      return {
        ...state,
        auditHistory: [],
        auditHistoryLoader: false,
      };
    case actionTypes.GET_AUDIT_HISTORY_LOADER:
      return {
        ...state,
        auditHistoryLoader: true,
      };
    default:
      return state;
  }
}
